
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Pencil, Trash2 } from "lucide-react";
import { Supplier } from "@/types/supplier";

interface SupplierCardProps {
  supplier: Supplier;
  onEdit: (supplier: Supplier) => void;
  onDelete: (id: string) => void;
}

export const SupplierCard = ({ supplier, onEdit, onDelete }: SupplierCardProps) => {
  return (
    <Card className="flex flex-col justify-between h-full">
      <CardHeader>
        <div className="flex justify-between items-start">
            <div>
                <CardTitle className="leading-relaxed mb-1">{supplier.name_ar}</CardTitle>
                {supplier.name_en && <CardDescription className="text-left" dir="ltr">{supplier.name_en}</CardDescription>}
            </div>
            <Badge variant={supplier.access_permission ? "default" : "secondary"}>
                {supplier.access_permission ? "لديه صلاحية" : "بدون صلاحية"}
            </Badge>
        </div>
      </CardHeader>
      <CardContent className="space-y-2 flex-grow">
        <p className="text-sm text-muted-foreground">
          <strong>الموظف:</strong> {supplier.employee_name_ar || 'غير محدد'}
        </p>
        <p className="text-sm text-muted-foreground">
          <strong>الدولة:</strong> {supplier.country || 'غير محدد'}
        </p>
        <p className="text-sm text-muted-foreground truncate" title={supplier.departments || ''}>
          <strong>الأقسام:</strong> {supplier.departments || 'غير محدد'}
        </p>
      </CardContent>
      <CardFooter>
        <div className="flex gap-2 justify-end w-full">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onEdit(supplier)}
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onDelete(supplier.id)}
            className="text-red-600 hover:text-red-700"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </CardFooter>
    </Card>
  );
};
